import React, { FC } from 'react';

import Loadable from 'react-loadable';

/* eslint frontbucket-patterns/no-old-dropdown-menu: "warn" */
import { DropdownItem } from '@atlaskit/dropdown-menu';
import Spinner from '@atlaskit/spinner';

import { ForgeRepoCodeOverviewActionAppsListProps } from './repo-code-overview-action-apps-list';

const LoadableDropdownAppList = Loadable({
  loading: () => (
    <DropdownItem>
      <Spinner size="small" />
    </DropdownItem>
  ),
  loader: () => import('./repo-code-overview-action-apps-list'),
});

export const preloadLoadableDropdownAppList = () => {
  LoadableDropdownAppList.preload();
};

export const LazyForgeRepoCodeOverviewActionAppsList: FC<
  Omit<ForgeRepoCodeOverviewActionAppsListProps, 'currentUser' | 'repository'>
> = props => {
  return <LoadableDropdownAppList {...props} />;
};
